




import { default as Component } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import DatePicker from '@/components/vuejs-datepicker/src/components/Datepicker.vue';
import MessagesBlock from '@/components/snippets/messages/MessagesBlock.vue';
import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';
import Format from '@/interfaces/Format';
import Api from '@/interfaces/Api';
import Tracking from '@/interfaces/Tracking';
import GenericMessagesBlock from '@/components/snippets/messages/GenericMessagesBlock.vue';
import Basic from '@/components/widgets/Basic.vue';

interface CityData {
  text: string;
  zip: string;
  zipText: string;
  name: string;
}

const ApiProvider = IocContainer.get<Api>(SERVICES.API);
const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);
const trackingProvider = IocContainer.get<Tracking>(SERVICES.TRACKING);

@Component({
  props: {},
  components: {
    'date-picker': DatePicker,
    'messages-block': MessagesBlock,
    'generic-messages-block': GenericMessagesBlock
  },
  filters: {
    zip: formatProvider.zip()
  }
})
export default class NonCommodityContractAddressWidget extends Basic {
  @Prop() public extendedDataParentKey!: string;
  @Prop() public minimumAgeRequired!: number;

  protected hideInputBirthday: boolean = false;
  protected searchLengthReached = false;
  protected searchQuery = '';
  protected cities: any = [];
  protected cityObject = {};
  public streets: any = [];
  public billingStreets: any = [];
  public forceUpdate: boolean = true;
  public hasErrors = false;
  public extendedData: Record<any, any> = {};
  public vwGroupAffiliationValue: { label: string; value: string } | null = null;

  public formSalutations = {
    mr: 1,
    mrs: 2,
    without: 9
  };

  protected afterSaveDateOfBirth(): void {
    return;
  }

  public saveDateOfBirth(date: string): void {
    this.forceUpdate = false;
    if (date) {
      this.setInputValue('dateOfBirth', date);
      // @ts-ignore
      // this.$refs.datepicker.selectDate(new Date(date));
    } else {
      this.setInputValue('dateOfBirth', null);
    }
    this.afterSaveDateOfBirth();
  }

  get streetsDisplay(): [] {
    return this.streets.map((street) => {
      return street.name;
    });
  }

  get billingStreetsDisplay(): [] {
    return this.billingStreets.map((street) => {
      return street.name;
    });
  }

  public onBillingStreetInput(street: string): void {
    this.setInputValue('billingStreet', street);
    this.updateFieldDisplayForElement(this.$el.querySelector('#billingStreet'));
  }

  public onStreetInput(street: string): void {
    this.setInputValue('street', street);
    this.updateFieldDisplayForElement(this.$el.querySelector('#street'));
  }

  public resetFields(...fields: string[]): void {
    fields.forEach((field) => {
      this.setInputValue(field, '');
      const that = this;
      setTimeout(function () {
        that.updateFieldDisplay(field, '');
      }, 1);
    });
  }

  public citySearch(search: string, field: string): void {
    if (search.length >= 3) {
      this.searchQuery = search;
      this.searchLengthReached = true;
    } else {
      this.searchQuery = search;
      this.searchLengthReached = false;
    }
  }

  protected onCitiesBillingInput(value: {
    id: string;
    text: string;
    zip: string;
    zipText: string;
    name: string;
  }): void {
    this.updateFieldDisplay('billingZip', value.zip);
    this.updateFieldDisplay('billingCity', value.name);
  }

  public citiesInputBilling(value: { id: string; text: string; zip: string; zipText: string; name: string }): void {
    if (value) {
      this.cityObject = value;
      this.setInputValue('billingZip', value.zip);
      this.setInputValue('billingCity', value.name);
      this.onCitiesBillingInput(value);
      ApiProvider.getStreets(value.zip).then((responseStreet) => {
        if (responseStreet.data.streets) {
          this.billingStreets = responseStreet.data.streets;
        }
      });
    }
  }

  protected onCitiesInput(value: { id: string; text: string; zip: string; zipText: string; name: string }): void {
    this.updateFieldDisplay('zip', value.zip);
    this.updateFieldDisplay('city', value.name);
  }

  public citiesInput(value: { id: string; text: string; zip: string; zipText: string; name: string }): void {
    if (value) {
      this.setInputValue('zip', value.zip);
      this.setInputValue('city', value.name);
      this.setInputValue('cityId', value.id);
      const that = this;
      setTimeout(function () {
        that.onCitiesInput(value);
      }, 1);
      ApiProvider.getStreets(value.zip).then((responseStreet) => {
        if (responseStreet.data.streets) {
          this.streets = responseStreet.data.streets;
        }
      });
    }
  }

  beforeMount(): void {
    if (this.cities.length === 0) {
      ApiProvider.getCities().then((responseCities) => {
        if (responseCities.data.cities) {
          this.cities = responseCities.data.cities;
        }
      });
    }
    if (this.sessionState.zip) {
      ApiProvider.getStreets(this.sessionState.zip).then((responseStreet) => {
        if (responseStreet.data.streets) {
          this.streets = responseStreet.data.streets;
        }
      });
    }
    if (this.sessionState.billingZip) {
      ApiProvider.getStreets(this.sessionState.billingZip).then((responseStreet) => {
        if (responseStreet.data.streets) {
          this.billingStreets = responseStreet.data.streets;
        }
      });
    }
  }

  get citiesDisplay(): CityData[] | [] {
    if (this.searchLengthReached) {
      const search = parseInt(this.searchQuery, 10) + '';
      const filteredCities = this.cities.filter((city) => {
        if (this.isNumeric(this.searchQuery)) {
          return new RegExp('^' + search).test(city.zip);
        } else {
          return new RegExp('^' + this.searchQuery, 'i').test(city.name);
        }
      });
      return this.citiesNormalizing(filteredCities, 'zip');
    } else {
      return [];
    }
  }

  get getErrorsBag(): any {
    return this.errorsBag;
  }

  public mounted(): void {
    this.checkIsFormComplete();
  }

  public contractSubmit(): Promise<void> {
    this.resetErrorBag();
    this.store.dispatch('resetErrors');

    const state = this.dataModifierHook();
    return ApiProvider.sessionUpdate(state)
      .then((response) => {
        this.validateContract(response);
      })
      .catch((error) => {
        if (error.response.status === 422) {
          this.errorsBag = error.response.data.errors;
          this.store.dispatch('setErrors', error.response.data.errors);
        }
        if (typeof error.response !== 'undefined' && error.response.data.message === 'session outdated') {
          localStorage.removeItem(process.env.VUE_APP_SESSION_STORAGE_KEY);
          window.location.href = document.referrer || window.location.origin;
        }
        this.$emit('addressSubmitUnsuccessful');
      });
  }

  public dataModifierHook(): void {
    return;
  }

  public validateContract(response): void {
    ApiProvider.validateContract()
      .then(() => {
        this.$emit('addressSubmit', response.data);
      })
      .catch((error) => {
        trackingProvider.validationContractFailed();
        if (error.response.data && typeof error.response.data.error !== 'undefined') {
          this.store.dispatch('setErrors', error.response.data.error.messages);
        }
        this.$emit('scrollToTop');
        this.$emit('addressSubmitUnsuccessful');
      });
  }

  protected isNumeric(value: string): boolean {
    return /^-{0,1}\d+$/.test(value);
  }

  protected citiesNormalizing(filteredCities: CityData[], type: string): CityData[] {
    return filteredCities.map((city) => {
      const cityNormalized = { ...city };
      if (cityNormalized.zip.length < 5) {
        cityNormalized.text = '0' + city.text;
        cityNormalized.zip = '0' + city.zip;
      }
      cityNormalized.zipText = type === 'zip' ? cityNormalized.zip : cityNormalized.text;
      return cityNormalized;
    });
  }

  get todayMinusMinimumAgeRequired(): Date {
    const now = new Date();
    if (this.$props.minimumAgeRequired && this.$props.minimumAgeRequired > 0) {
      return new Date(now.setFullYear(now.getFullYear() - this.$props.minimumAgeRequired));
    } else {
      return now;
    }
  }

  public get taxNumber(): string {
    return this.extendedData[this.extendedDataParentKey].TAX_NUMBER_MULTI
      ? this.extendedData[this.extendedDataParentKey].TAX_NUMBER_MULTI
      : '';
  }

  public set taxNumber(taxNumber: string) {
    this.extendedData[this.extendedDataParentKey].TAX_NUMBER_MULTI = taxNumber;
    this.store.dispatch('setSessionExtendedData', { [this.extendedDataParentKey]: { TAX_NUMBER_MULTI: taxNumber } });
    this.checkIsFormComplete();
  }

  public get vatId(): string {
    return this.extendedData[this.extendedDataParentKey].VAT_ID_MULTIYEAR
      ? this.extendedData[this.extendedDataParentKey].VAT_ID_MULTIYEAR
      : '';
  }

  public set vatId(vatId: string) {
    this.extendedData[this.extendedDataParentKey].VAT_ID_MULTIYEAR = vatId;
    this.store.dispatch('setSessionExtendedData', { [this.extendedDataParentKey]: { VAT_ID_MULTIYEAR: vatId } });
    this.checkIsFormComplete();
  }

  protected onInputValueSet(): void {
    this.checkIsFormComplete();
  }

  @Watch('sessionState')
  protected checkIsFormComplete(): boolean {
    if (this.hideInputBirthday && this.sessionState.dateOfBirth == null) {
      this.sessionState.dateOfBirth = '1900-01-01';
    }

    const mandatoryFields: any[] = [
      this.sessionState.salutation,
      this.sessionState.firstName,
      this.sessionState.surname,
      this.sessionState.emailPrivate,
      this.sessionState.street,
      this.sessionState.houseNumber,
      this.sessionState.zip,
      this.sessionState.city
    ];

    if (this.sessionState.business === 1) {
      mandatoryFields.push(this.sessionState.billingCompany);
    }

    if (!this.hideInputBirthday) {
      mandatoryFields.push(this.sessionState.dateOfBirth);
      if (this.isErrorMinimumAgeRequired) {
        return false;
      }
    }

    for (let i = 0; i < mandatoryFields.length; ++i) {
      if (mandatoryFields[i] == null || mandatoryFields[i].length == 0) {
        this.$emit('onPending');
        return false;
      }
    }
    if (this.sessionState.business === 1) {
      if (!this.vatId && !this.taxNumber) {
        this.$emit('onPending');
        return false;
      }
      if (!this.currentClient.includes('thg-freenet') && !this.vwGroupAffiliationValue) {
        this.$emit('onPending');
        return false;
      }
    }
    this.$emit('onReady');
    return true;
  }

  get isErrorMinimumAgeRequired(): boolean {
    return this.errorMinimumAgeRequired !== null;
  }

  get disabledDatesOfBirth(): { from: Date } {
    const date = new Date();
    if (this.$props.minimumAgeRequired) {
      date.setFullYear(date.getFullYear() - this.$props.minimumAgeRequired);
    }
    return { from: date };
  }

  get errorMinimumAgeRequired(): [{ key: string; message: string }] | null {
    const message = this.$t('contract.widget.min.age.required', {
      years: this.$props.minimumAgeRequired
    }).toString();
    return this.disabledDatesOfBirth.from.getTime() < new Date(this.sessionState.dateOfBirth || 0).getTime()
      ? [{ key: '', message }]
      : null;
  }

  protected checkValidForm(): void | boolean {
    if (this.isErrorMinimumAgeRequired) {
      return false;
    }
    this.contractSubmit();
  }
}
